// Calm Bento FE - renders the bento shell.
// Data layer is decoupled via the LifeOsApi contract:
//   - production: useLifeOs (local-first + optional Supabase realtime sync)
//   - fallback/demo: useLifeOsStub (in-memory, same interface)
import { BentoShell } from "./bento/bento-shell";
import { AuthGate } from "./bento/auth-gate";
import { useLifeOs } from "./hooks/useLifeOs";

function App() {
  const api = useLifeOs();
  // Cloud-sync builds: block the whole app behind sign-in (no guest/demo access).
  // Local-only builds bypass the gate inside AuthGate (no accounts there).
  return (
    <AuthGate api={api}>
      <BentoShell api={api} />
    </AuthGate>
  );
}

export default App;
